// extracted by mini-css-extract-plugin
export default {"container":"Error_container__L61Rd","ErrorContainer":"Error_ErrorContainer__yyeZb"};